<nz-select
nzMode="tags"
nzPlaceHolder="Enter email address, press Enter or semicolon to add"
[nzMaxTagCount]="10"
[nzTokenSeparators]="[',', ';']"
[(ngModel)]="emails"
(ngModelChange)="onEmailsChange($event)"
(nzOnSearch)="onSearchChange($event)"
(keydown)="onKeyDown($event)"
[nzDisabled]="disabled"
[class.limit-reached]="isLimitReached()"
[class.near-limit]="isNearLimit()"
style="width: 100%">
    <nz-option 
    *ngFor="let email of emails; let i = index" 
    [nzLabel]="getEmailDisplay(email, i)" 
    [nzValue]="email">
    </nz-option>
</nz-select>

<!-- 字符计数和限制提示 -->
<div *ngIf="showCharCount" class="character-count-container">
  <!-- 当前输入email的字符计数 -->
  <div *ngIf="getCurrentInputLength() > 0" class="text-right text-xs mt-1" 
       [class.text-red-500]="isLimitReached()" 
       [class.text-orange-500]="isNearLimit() && !isLimitReached()"
       [class.text-gray-500]="!isNearLimit()">
    当前输入: {{ getCurrentInputLength() }}/{{ maxLength }} 字符
  </div>
  
  <!-- 达到限制时的警告提示 -->
  <div *ngIf="isLimitReached()" class="text-red-500 text-xs mt-1">
    ⚠️ 单个邮箱地址已达到最大字符限制 ({{ maxLength }} 字符)，无法继续输入
  </div>
</div>
